import { AutoComplete } from 'antd';
import { FormSelect } from 'components/Custom/selects';
import { FormInput, FormTextArea } from 'components/Custom/inputs';
import { ScopeButton } from '@monorepo/shared-lib';
import styled, { createGlobalStyle } from 'styled-components';

export const ExtractionRulesDrawerStyle = createGlobalStyle`
  .ant-drawer-body:has(.extraction-rules-wrapper) {
    padding-bottom: 0 !important;
  }
`;

export const ExtractionRuleModalAntTypographyStyle = createGlobalStyle`
  .extraction-rule-modal .ant-segmented-item-label {
    font-size: 12px !important;
  }

  .extraction-rule-modal .ant-spin-text {
    font-size: 12px !important;
  }
`;

export const ExtractionRulesSelectDropdownStyle = createGlobalStyle`
  .extraction-rules-select-dropdown.ant-select-dropdown .ant-select-item {
    font-size: 13px;
    min-height: 36px;
    padding-top: 6px;
    padding-bottom: 6px;
  }

  .extraction-rules-select-dropdown.ant-select-dropdown .ant-select-item-group {
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    color: var(--color-text-muted, #5a6a6a);
    padding-top: 10px;
    padding-bottom: 4px;
    min-height: auto;
  }

  .extraction-rules-select-dropdown.ant-select-dropdown
    .ant-select-item-group:first-child {
    padding-top: 4px;
  }
`;

export const ExtractionRulesFormControlStyle = createGlobalStyle`
  .scope-extraction-rules-select.scope-form-select.ant-select {
    border: 1px solid var(--color-border, #dbeae3) !important;
    border-radius: 8px !important;
    overflow: hidden;
    box-shadow: none !important;
    background: var(--color-surface-raised, #ffffff) !important;
    font-size: 12px;

    .ant-select-selector {
      border: 1px solid transparent !important;
      border-radius: 8px !important;
      box-shadow: none !important;
      background: var(--color-surface-raised, #ffffff) !important;
    }

    &:not(.ant-select-disabled):hover,
    &.ant-select-focused,
    &.ant-select-open {
      border: 1px solid var(--color-primary, #41aaaf) !important;
      box-shadow: none !important;
    }

    &:not(.ant-select-disabled):hover .ant-select-selector,
    &.ant-select-focused .ant-select-selector,
    &.ant-select-open .ant-select-selector {
      border: 1px solid transparent !important;
      box-shadow: none !important;
    }
  }

  .scope-extraction-rules-input.scope-form-input.ant-input {
    border: 1px solid var(--color-border, #dbeae3) !important;
    border-radius: 8px !important;
    box-shadow: none !important;
    background: var(--color-surface-raised, #ffffff) !important;
    color: var(--color-text-dark, #042a2a) !important;
    font-size: 12px;
  }

  .scope-extraction-rules-input.scope-form-input.ant-input:hover,
  .scope-extraction-rules-input.scope-form-input.ant-input:focus {
    border: 1px solid var(--color-primary, #41aaaf) !important;
    box-shadow: none !important;
  }

  .scope-extraction-rules-input.scope-form-input.ant-input[disabled],
  .scope-extraction-rules-input.scope-form-input.ant-input.ant-input-disabled {
    background: var(--color-surface, #f3f7f8) !important;
    color: var(--color-text-muted, #5a6a6a) !important;
    border-color: var(--color-border, #dbeae3) !important;
  }

  .scope-extraction-rules-name-input.scope-form-input.ant-input {
    border: 1px solid var(--color-border, #dbeae3) !important;
    border-radius: 8px !important;
    box-shadow: none !important;
    background: var(--color-surface-raised, #ffffff) !important;
    color: var(--color-text-dark, #042a2a) !important;
    font-size: 14px !important;
  }

  .scope-extraction-rules-name-input.scope-form-input.ant-input:hover,
  .scope-extraction-rules-name-input.scope-form-input.ant-input:focus {
    border: 1px solid var(--color-primary, #41aaaf) !important;
    box-shadow: none !important;
  }

  .scope-extraction-rules-textarea.ant-input {
    border: 1px solid var(--color-border, #dbeae3) !important;
    border-radius: 8px !important;
    box-shadow: none !important;
    background: var(--color-surface-raised, #ffffff) !important;
    color: var(--color-text-dark, #042a2a) !important;
    font-size: 13px !important;
    line-height: 1.5 !important;
  }

  .scope-extraction-rules-textarea.ant-input::placeholder {
    color: var(--color-text-muted, #5a6a6a) !important;
    opacity: 1 !important;
  }

  .scope-extraction-rules-textarea.ant-input:hover,
  .scope-extraction-rules-textarea.ant-input:focus {
    border: 1px solid var(--color-primary, #41aaaf) !important;
    box-shadow: none !important;
  }
`;

export const FieldSelectOptionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  line-height: 1.3;
  white-space: normal;
`;

export const FieldOptionTitle = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: var(--color-text-dark, #042a2a);
`;

export const FieldOptionDescription = styled.div`
  font-size: 11px;
  font-weight: 400;
  color: var(--color-text-muted, #5a6a6a);
`;

export const DrawerWrapper = styled.div`
  font-family: Inter, sans-serif;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  min-height: 0;
  height: 100%;
  width: 100%;
`;

export const DrawerTopSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex-shrink: 0;
`;

export const DrawerIntro = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.55;
  color: var(--color-text-muted, #5a6a6a);
`;

export const DrawerToolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  flex-shrink: 0;
`;

export const DrawerStatsBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  background: var(--color-status-success-bg, #e9f6f7);
  border: 1px solid var(--color-border, #dbeae3);
  font-size: 13px;
  font-weight: 600;
  color: var(--color-status-success, #058181);
  white-space: nowrap;
`;

export const RulesListContainer = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const RulesSearchRow = styled.div`
  flex-shrink: 0;
`;

export const RulesSearchNoResults = styled.div`
  flex-shrink: 0;
  font-size: 12px;
  color: var(--color-text-muted, #5a6a6a);
`;

export const RulesPaginationRow = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  flex-shrink: 0;
  padding-bottom: 20px;
`;

export const RulesListWrapper = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 4px 0 0;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const RulesListPanel = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;

export const ColumnHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  font-weight: 600;
  color: var(--color-text-dark, #042a2a);
  padding: 0 0 8px;
  margin-bottom: 0;
  border-bottom: 1px solid var(--color-border, #dbeae3);
  flex-shrink: 0;
`;

export const ColumnHeaderLeft = styled.div`
  flex: 1;
`;

export const ColumnHeaderRight = styled.div`
  flex-shrink: 0;
  width: 80px;
  text-align: right;
`;

export const RuleListItem = styled.div<{ $enabled?: boolean }>`
  border: 2px solid var(--color-border, #dbeae3);
  border-radius: 16px;
  padding: 10px 12px;
  background: var(--color-surface-raised, #ffffff);
  box-shadow: none;
  transition: border-color 0.15s ease, opacity 0.15s ease;
  opacity: ${(p) => (p.$enabled ? 1 : 0.82)};

  &:hover {
    border-color: var(--color-primary-hover, #64bbbd);
  }
`;

export const RuleListItemHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
`;

export const RuleListItemLeft = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  flex: 1;
  min-width: 0;
`;

export const RuleListItemContent = styled.button`
  flex: 1;
  min-width: 0;
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  text-align: left;
  cursor: pointer;
  font: inherit;
  color: inherit;

  &:focus-visible {
    outline: 2px solid rgba(65, 170, 175, 0.45);
    outline-offset: 2px;
    border-radius: 6px;
  }
`;

export const RuleListItemRight = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  padding-top: 2px;
`;

export const RuleListItemTitle = styled.span`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  font-size: 12px;
  color: var(--color-text-dark, #042a2a);
  font-weight: 600;
  line-height: 1.35;
  word-break: break-word;
`;

export const RuleListItemMetaDate = styled.span`
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: var(--color-text-muted, #5a6a6a);
  line-height: 1.35;
`;

export const RuleListItemTextColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  flex: 1;
`;

export const RuleListItemContents = styled.div`
  padding: 8px 0 8px 24px;
  background-color: var(--color-surface, #f3f7f8);
  border-top: 1px solid var(--color-border, #dbeae3);
  font-size: 12px;
  color: var(--color-text-muted, #5a6a6a);
  line-height: 1.6;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 36px 20px;
  text-align: center;
  border: 1px dashed var(--color-border, #dbeae3);
  border-radius: 16px;
  background: var(--color-surface-raised, #ffffff);
`;

export const EmptyStateIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 999px;
  background: var(--color-layout-bg, #e9f6f7);
  color: var(--color-primary, #41aaaf);
  font-size: 20px;
  line-height: 1;
`;

export const EmptyStateText = styled.p`
  margin: 0;
  max-width: 280px;
  font-size: 14px;
  line-height: 1.55;
  color: var(--color-text-muted, #5a6a6a);
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const ToolbarActionButton = styled(ScopeButton)`
  font-size: 14px;
`;

export const ModalRoot = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  padding: 0;
`;

export const ModalScrollBody = styled.div.attrs({
  className: 'scope-extraction-rule-scroll',
})`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0 0 4px;
  box-sizing: border-box;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--color-border, #dbeae3);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }
`;

export const ModalFooterBar = styled.div.attrs({
  className: 'scope-extraction-rule-footer',
})`
  flex-shrink: 0;
  margin-top: auto;
  padding: 12px 0 0;
  margin-bottom: 0;
  border-top: 1px solid var(--color-border, #dbeae3);
  background: var(--color-surface-raised, #ffffff);
`;

export const AuthoringChoiceHeading = styled.h3`
  margin: 0 0 8px;
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text-dark, #042a2a);
  line-height: 1.4;
`;

export const AuthoringChoiceRow = styled.div.attrs({
  className: 'scope-extraction-authoring-row',
})`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 10px;
  align-items: center;
  margin-bottom: 4px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    justify-items: stretch;
  }
`;

export const AuthoringChoiceOr = styled.span`
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--color-text-muted, #5a6a6a);
  padding: 0 2px;
  user-select: none;

  @media (max-width: 640px) {
    justify-self: center;
    padding: 2px 0;
  }
`;

export const ScanningDocumentsSpinner = styled.span`
  width: 20px;
  padding: 6px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: #25b09b;
  --_m: conic-gradient(#0000 10%, #000), linear-gradient(#000 0 0) content-box;
  -webkit-mask: var(--_m);
  mask: var(--_m);
  -webkit-mask-composite: source-out;
  mask-composite: subtract;
  animation: scopeScanSpin 1s infinite linear;
  flex-shrink: 0;

  @keyframes scopeScanSpin {
    to {
      transform: rotate(1turn);
    }
  }
`;

export const OrangeSpinnerRing = styled.span`
  width: 24px;
  height: 24px;
  border-radius: 999px;
  border: 2px solid var(--btn-accent-bg, #ffbc3e);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  & > span {
    width: 20px;
    height: 20px;
  }
`;

export const AuthoringChoiceCard = styled.button.attrs({
  className: 'scope-extraction-authoring-card',
})<{ $selected?: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 14px 16px;
  margin: 0;
  border: 2px solid ${(p) => (p.$selected ? 'var(--color-primary, #41aaaf)' : 'var(--color-border, #dbeae3)')};
  border-radius: 12px;
  background: ${(p) => (p.$selected ? 'var(--color-primary-soft, #e6f7f7)' : 'var(--color-surface-raised, #ffffff)')};
  box-shadow: ${(p) =>
    p.$selected
      ? '0 2px 8px rgba(65, 170, 175, 0.12)'
      : '0 1px 3px rgba(4, 42, 42, 0.04)'};
  cursor: pointer;
  text-align: left;
  font: inherit;
  color: inherit;
  transition: border-color 0.15s ease, background-color 0.15s ease,
    box-shadow 0.15s ease;
  width: 100%;
  box-sizing: border-box;

  &:hover {
    border-color: ${(p) => (p.$selected ? 'var(--color-primary, #41aaaf)' : 'var(--color-primary-hover, #64bbbd)')};
  }

  &:focus-visible {
    outline: 2px solid rgba(65, 170, 175, 0.45);
    outline-offset: 2px;
  }
`;

export const AuthoringChoiceIcon = styled.span<{ $selected?: boolean }>`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: ${(p) => (p.$selected ? 'var(--color-layout-bg, #e9f6f7)' : 'var(--color-surface, #f3f7f8)')};
  color: ${(p) => (p.$selected ? 'var(--color-primary, #41aaaf)' : 'var(--color-text-muted, #5a6a6a)')};
  font-size: 15px;
  line-height: 1;
`;

export const AuthoringAiBadge = styled.span`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: var(--color-status-warning-bg, #fff5e2);
  border: 1px solid var(--color-border, #dbeae3);
  color: var(--color-status-warning, #c38a20);
  margin-left: auto;

  & > svg {
    width: 20px;
    height: 20px;
    display: block;
  }
`;

export const AuthoringChoiceText = styled.span`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const AuthoringChoiceTitle = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text-dark, #042a2a);
  line-height: 1.35;
`;

export const AuthoringChoiceDescription = styled.span`
  font-size: 11px;
  line-height: 1.4;
  color: var(--color-text-muted, #5a6a6a);
`;

export const DescribePanel = styled.div`
  border: 1px solid var(--color-border, #dbeae3);
  border-radius: 12px;
  background: var(--color-surface-raised, #ffffff);
  padding: 16px 18px;
  box-shadow: 0 1px 3px rgba(4, 42, 42, 0.04);
`;

export const DescribePanelTitle = styled.h4`
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text-dark, #042a2a);
  line-height: 1.35;
`;

export const DescribePanelSubtitle = styled.p`
  margin: 4px 0 0;
  font-size: 12px;
  line-height: 1.45;
  color: var(--color-text-muted, #5a6a6a);
`;

export const DescribeInputBlock = styled.div.attrs({
  className: 'scope-extraction-describe-input',
})`
  margin-top: 14px;
  padding: 14px 16px;
  border: 1px solid var(--color-border, #dbeae3);
  border-radius: 10px;
  background: var(--color-surface, #f3f7f8);
  box-sizing: border-box;
`;

export const DescribeInputLabel = styled.label`
  display: block;
  margin-bottom: 8px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: var(--color-text-muted, #5a6a6a);
`;

export const DescribeInputHint = styled.p`
  margin: 8px 0 0;
  font-size: 11px;
  line-height: 1.4;
  color: var(--color-text-muted, #5a6a6a);
`;

export const DescribeExamplesSection = styled.div`
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid var(--color-border, #dbeae3);
`;

export const DescribeExamplesHeading = styled.div`
  margin-bottom: 8px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: var(--color-text-muted, #5a6a6a);
`;

export const DescribeParseFeedback = styled.div`
  margin-top: 14px;
  padding: 14px 16px;
  border-radius: 10px;
  border: 1px solid var(--color-border, #dbeae3);
  background: var(--color-status-warning-bg, #fff5e2);
  scroll-margin-bottom: 20px;
`;

export const DescribeParseFeedbackHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
`;

export const DescribeParseFeedbackIcon = styled.span`
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--color-primary-soft, #e6f7f7);
  color: var(--color-status-warning, #c38a20);
  font-size: 12px;
`;

export const DescribeParseFeedbackText = styled.div`
  min-width: 0;
`;

export const DescribeParseFeedbackTitle = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: var(--color-text-base, #2e2e2e);
  line-height: 1.4;
`;

export const DescribeParseFeedbackDetail = styled.p`
  margin: 4px 0 0;
  font-size: 11px;
  line-height: 1.45;
  color: var(--color-text-muted, #5a6a6a);
`;

export const DescribeParseSuggestionsHeading = styled.div`
  margin: 12px 0 8px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: var(--color-text-muted, #5a6a6a);
`;

export const DescribeParseSuggestionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const DescribeParseSuggestionChip = styled.button`
  margin: 0;
  padding: 8px 12px;
  border: 1px solid var(--color-border, #dbeae3);
  border-radius: 8px;
  background: var(--color-surface-raised, #ffffff);
  font-size: 11px;
  line-height: 1.45;
  color: var(--color-text-dark, #042a2a);
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  transition: border-color 0.15s ease, background-color 0.15s ease;

  &:hover {
    border-color: var(--color-primary-hover, #64bbbd);
    background: var(--color-primary-soft, #e6f7f7);
  }

  &:focus-visible {
    outline: 2px solid rgba(201, 138, 0, 0.45);
    outline-offset: 2px;
  }
`;

export const DescribeExampleList = styled.div.attrs({
  className: 'scope-extraction-example-list',
})`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 10px;
`;

export const DescribeExampleChip = styled.button.attrs({
  className: 'scope-extraction-example-chip',
})`
  margin: 0;
  padding: 6px 10px;
  border: 1px solid var(--color-border, #dbeae3);
  border-radius: 999px;
  background: var(--color-surface, #f3f7f8);
  font-size: 11px;
  line-height: 1.35;
  color: var(--color-text-muted, #5a6a6a);
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  transition: border-color 0.15s ease, background-color 0.15s ease,
    color 0.15s ease;
  max-width: 100%;
  box-sizing: border-box;

  &:hover {
    border-color: var(--color-primary-hover, #64bbbd);
    background: var(--color-primary-soft, #e6f7f7);
    color: var(--color-text-dark, #042a2a);
  }

  &:focus-visible {
    outline: 2px solid rgba(65, 170, 175, 0.45);
    outline-offset: 2px;
  }
`;

export const RuleNameSection = styled.div.attrs({
  className: 'scope-extraction-rule-name-section',
})`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px 18px;
  margin-bottom: 0;
  border: 1px solid var(--color-border, #dbeae3);
  border-radius: 12px;
  background: var(--color-surface, #f3f7f8);
  box-shadow: 0 1px 3px rgba(4, 42, 42, 0.04);
  min-width: 0;
  height: 100%;
  box-sizing: border-box;
`;

export const RuleNameSectionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-width: 0;
`;

export const RuleNameLabel = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-dark, #042a2a);
  line-height: 1.35;
  min-width: 0;
`;

export const RuleNameInputWrap = styled.div`
  width: 100%;
  min-width: 0;
`;

export const RuleNameAuthoringRow = styled.div<{ $singleColumn?: boolean }>`
  display: grid;
  grid-template-columns: ${(p) =>
    p.$singleColumn ? '1fr' : 'minmax(0, 1fr) minmax(0, calc(50% - 50px))'};
  gap: 12px;
  align-items: stretch;
  min-width: 0;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const RuleNameInput = styled(FormInput).attrs((props) => ({
  className: [props.className, 'scope-extraction-rules-name-input']
    .filter(Boolean)
    .join(' '),
}))<{ $invalid?: boolean }>`
  && {
    width: 100%;
    height: 42px !important;
    min-height: 42px !important;
    font-size: 14px !important;
    font-weight: 500;
    border-color: ${(p) => (p.$invalid ? 'var(--color-status-danger, #d13131)' : 'var(--color-border, #dbeae3)')} !important;
    background: var(--color-surface-raised, #ffffff) !important;
  }

  &&::placeholder {
    font-weight: 400;
    color: var(--color-text-muted, #5a6a6a);
  }
`;

export const RuleNameError = styled.div`
  margin-top: 6px;
  font-size: 12px;
  line-height: 1.45;
  color: var(--color-status-danger, #d13131);
`;
export const RuleBuilderFlow = styled.div.attrs({
  className: 'scope-extraction-rule-builder-flow',
})`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const RuleStepNumber = styled.span<{
  $state: 'pending' | 'active' | 'complete';
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 700;
  border: 2px solid
    ${(p) =>
      p.$state === 'complete'
        ? 'var(--color-primary, #41aaaf)'
        : p.$state === 'active'
          ? 'var(--btn-accent-bg, #ffbc3e)'
          : 'var(--color-border, #dbeae3)'};
  background: ${(p) =>
    p.$state === 'complete'
      ? 'var(--color-primary-soft, #e6f7f7)'
      : p.$state === 'active'
        ? 'var(--color-status-warning-bg, #fff5e2)'
        : 'var(--color-surface-raised, #ffffff)'};
  color: ${(p) =>
    p.$state === 'complete'
      ? 'var(--color-primary, #41aaaf)'
      : p.$state === 'active'
        ? 'var(--color-text-dark, #042a2a)'
        : 'var(--color-text-muted, #5a6a6a)'};
`;

export const RuleStepCard = styled.div.attrs({
  className: 'scope-extraction-rule-step-card',
})<{ $collapsed?: boolean; $active?: boolean }>`
  border: 1px solid
    ${(p) => (p.$active ? 'var(--color-primary-hover, #64bbbd)' : p.$collapsed ? 'var(--color-border, #dbeae3)' : 'var(--color-border, #dbeae3)')};
  border-radius: 12px;
  background: ${(p) => (p.$collapsed ? 'var(--color-surface, #f3f7f8)' : 'var(--color-surface-raised, #ffffff)')};
  overflow: hidden;
  box-shadow: ${(p) =>
    p.$active
      ? '0 2px 8px rgba(4, 42, 42, 0.06)'
      : '0 1px 3px rgba(4, 42, 42, 0.04)'};
  transition: border-color 0.15s ease, background-color 0.15s ease,
    box-shadow 0.15s ease;
`;

export const RuleStepHeader = styled.div.attrs({
  className: 'scope-extraction-rule-step-header',
})<{ $clickable?: boolean; $hasBody?: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 14px;
  border-bottom: ${(p) => (p.$hasBody ? '1px solid var(--color-border, #dbeae3)' : 'none')};
  background: var(--color-surface, #f3f7f8);
  cursor: ${(p) => (p.$clickable ? 'pointer' : 'default')};
  box-sizing: border-box;

  ${(p) =>
    p.$clickable
      ? `
    &:hover {
      background: var(--color-surface, #f3f7f8);
    }
  `
      : ''}
`;

export const RuleStepHeaderText = styled.div`
  flex: 1;
  min-width: 0;
`;

export const RuleStepTitleRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`;

export const RuleStepTitle = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text-dark, #042a2a);
  line-height: 1.35;
`;

export const StepBadge = styled.span.attrs({
  className: 'scope-extraction-step-badge',
})<{ $variant: 'optional' | 'required' }>`
  display: inline-flex;
  align-items: center;
  padding: 1px 7px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  background: ${(p) => (p.$variant === 'required' ? 'var(--color-status-warning-bg, #fff5e2)' : 'var(--color-surface, #f3f7f8)')};
  color: ${(p) => (p.$variant === 'required' ? 'var(--color-status-warning, #c38a20)' : 'var(--color-text-muted, #5a6a6a)')};
  border: 1px solid
    ${(p) => (p.$variant === 'required' ? 'var(--color-border, #dbeae3)' : 'var(--color-border, #dbeae3)')};
`;

export const RuleStepDescription = styled.p`
  margin: 4px 0 0;
  font-size: 12px;
  line-height: 1.5;
  color: var(--color-text-muted, #5a6a6a);
`;

export const RuleStepBody = styled.div.attrs({
  className: 'scope-extraction-rule-step-body',
})`
  padding: 12px 14px 14px;
  box-sizing: border-box;
`;

export const RuleStepHeaderActions = styled.div`
  flex-shrink: 0;
  padding-top: 2px;
`;

export const RuleStepChevron = styled.span<{ $expanded?: boolean }>`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin-top: 2px;
  color: var(--color-text-muted, #5a6a6a);
  font-size: 11px;
  transition: transform 0.15s ease, color 0.15s ease;
  transform: rotate(${(p) => (p.$expanded ? '180deg' : '0deg')});

  ${RuleStepHeader}[role='button']:hover & {
    color: var(--color-primary, #41aaaf);
  }
`;

export const StepActionButton = styled(ScopeButton)`
  && {
    font-size: 11px !important;
    line-height: 1.2 !important;
    padding: 0 8px !important;
    min-height: 22px !important;
    height: 22px !important;
  }

  && .ant-btn-icon {
    font-size: 10px !important;
  }
`;

export const StepEmptyHint = styled.div`
  padding: 14px 16px;
  border-radius: 8px;
  border: 1px dashed var(--color-border, #dbeae3);
  background: var(--color-surface, #f3f7f8);
  font-size: 12px;
  line-height: 1.55;
  color: var(--color-text-muted, #5a6a6a);
  text-align: center;
  box-sizing: border-box;
`;

export const Section = styled.div`
  margin-bottom: 0;
`;

export const SectionTitle = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: var(--color-text-dark, #042a2a);
  margin-bottom: 8px;
`;

export const SectionHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`;

export const HelperText = styled.div`
  font-size: 12px;
  color: var(--color-text-muted, #5a6a6a);
  margin-bottom: 8px;
`;

export const RuleFieldList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const RuleFieldItem = styled.li`
  padding: 7px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  border-radius: 10px;

  &:hover {
    background-color: var(--color-layout-bg, #e9f6f7);
  }
`;

export const RuleFieldLabel = styled.span`
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  color: var(--color-text-muted, #5a6a6a);
  flex: 1;
`;

export const RuleMapSelect = styled(FormSelect)`
  overflow: hidden;
  border-radius: 8px !important;

  .ant-select-selector,
  .ant-select-selection-item {
    font-size: 12px !important;
    color: var(--color-text-dark, #042a2a) !important;
  }

  .ant-select-selector {
    min-height: 33px !important;
    height: 33px !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    box-sizing: border-box;
  }

  .ant-select-selection-item,
  .ant-select-selection-placeholder {
    line-height: 31px !important;
  }

  .ant-select-selection-placeholder {
    color: var(--color-text-muted, #5a6a6a) !important;
  }
`;

export const RuleMapInput = styled(FormInput).attrs((props) => ({
  className: [props.className, 'scope-extraction-rules-input']
    .filter(Boolean)
    .join(' '),
}))`
  height: 35px !important;
  min-height: 35px !important;
  font-size: 12px !important;

  .ant-input {
    height: 33px !important;
    font-size: 12px !important;
  }
`;

export const RuleMapAutoComplete = styled(AutoComplete).attrs((props) => ({
  className: [props.className, 'scope-extraction-rules-input']
    .filter(Boolean)
    .join(' '),
}))`
  width: 60%;
  flex-shrink: 0;

  .ant-select-selector,
  .ant-select-selection-item,
  .ant-select-selection-search-input {
    font-size: 12px !important;
    color: var(--color-text-dark, #042a2a) !important;
  }

  .ant-select-selector {
    min-height: 33px !important;
    height: 33px !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    border-radius: 8px !important;
    box-sizing: border-box;
  }

  .ant-select-selection-search-input {
    height: 31px !important;
  }

  .ant-select-selection-placeholder {
    line-height: 31px !important;
    color: var(--color-text-muted, #5a6a6a) !important;
    font-size: 12px !important;
  }
`;

export const RuleDescribeTextArea = styled(FormTextArea).attrs((props) => ({
  className: [props.className, 'scope-extraction-rules-textarea']
    .filter(Boolean)
    .join(' '),
}))`
  width: 100% !important;
  min-height: 108px !important;
  max-height: 160px !important;
  height: 108px !important;
  font-size: 13px !important;
  resize: vertical !important;
`;

export const DescribeMentionWrap = styled.div`
  position: relative;
`;

export const DescribeMentionPanel = styled.div`
  position: absolute;
  z-index: 20;
  max-height: 220px;
  overflow: auto;
  border: 1px solid var(--color-border, #dbeae3);
  border-radius: 10px;
  background: var(--color-surface-raised, #ffffff);
  box-shadow: 0 8px 24px rgba(4, 42, 42, 0.12);
`;

export const DescribeMentionList = styled.div`
  padding: 6px;
`;

export const DescribeMentionGroup = styled.div`
  &:not(:first-child) {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid var(--color-border, #dbeae3);
  }

  > div:first-child {
    padding: 4px 8px;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: var(--color-text-muted, #5a6a6a);
  }
`;

export const DescribeMentionItem = styled.button<{ $active?: boolean }>`
  display: block;
  width: 100%;
  margin: 0;
  padding: 8px 10px;
  border: none;
  border-radius: 8px;
  background: ${({ $active }) => ($active ? 'var(--color-primary-soft, #e6f7f7)' : 'transparent')};
  text-align: left;
  font: inherit;
  font-size: 12px;
  color: var(--color-text-dark, #042a2a);
  cursor: pointer;

  &:hover,
  &:focus-visible {
    background: var(--color-primary-soft, #e6f7f7);
    outline: none;
  }
`;

export const ConditionLogicRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
  padding: 0 12px;
`;

export const ConditionConnector = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 4px 0 8px;
  font-size: 11px;
  font-weight: 600;
  color: var(--color-text-muted, #5a6a6a);
  letter-spacing: 0.04em;
`;

export const ConditionBlock = styled.div`
  margin-bottom: 10px;
  border: 1px solid var(--color-border, #dbeae3);
  border-radius: 10px;
  overflow: hidden;
  background: var(--color-surface-raised, #ffffff);

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ConditionBlockHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: var(--color-surface, #f3f7f8);
  border-bottom: 1px solid var(--color-border, #dbeae3);
  font-size: 12px;
  font-weight: 500;
  color: var(--color-text-muted, #5a6a6a);
`;

export const PreviewBox = styled.div`
  background: var(--color-surface, #f3f7f8);
  border: 1px solid var(--color-border, #dbeae3);
  border-radius: 10px;
  padding: 14px 16px;
  font-size: 13px;
  color: var(--color-text-dark, #042a2a);
  line-height: 1.55;
`;

export const ReviewEnabledRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid var(--color-border, #dbeae3);
`;

export const ReviewEnabledLabel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const ReviewEnabledTitle = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: var(--color-text-dark, #042a2a);
`;

export const ReviewEnabledHint = styled.span`
  font-size: 12px;
  color: var(--color-text-muted, #5a6a6a);
  line-height: 1.45;
`;

export const FooterButtons = styled.div.attrs({
  className: 'scope-extraction-footer-buttons',
})`
  display: grid;
  grid-template-columns: minmax(96px, 1fr) minmax(96px, 1fr);
  align-items: center;
  column-gap: 12px;
  width: 100%;
  min-height: 32px;
  margin-bottom: 0;
`;

export const FooterLeft = styled.div.attrs({
  className: 'scope-extraction-footer-left',
})`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-width: 0;
`;

export const FooterRight = styled.div.attrs({
  className: 'scope-extraction-footer-right',
})`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-width: 0;
  overflow: hidden;
`;

export const FooterRightButtons = styled.div.attrs({
  className: 'scope-extraction-footer-right-buttons',
})`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  max-width: 100%;
`;

export const FooterButton = styled(ScopeButton).attrs((props) => ({
  className: ['scope-extraction-footer-cancel', props.className]
    .filter(Boolean)
    .join(' '),
}))`
  width: 96px;
  height: 32px;
  font-size: 13px;
  border-radius: 50px;
`;

export const FooterPrimaryButton = styled(ScopeButton).attrs((props) => ({
  className: ['scope-extraction-footer-primary', props.className]
    .filter(Boolean)
    .join(' '),
}))`
  height: 32px;
  min-width: 96px;
  width: fit-content;
  padding: 0 16px;
  font-size: 13px;
  border-radius: 50px;
`;

type MapSelectFilterOption = {
  label?: unknown;
  value?: unknown;
  searchText?: string;
  options?: Array<{ label?: unknown; searchText?: string }>;
};

/** Ant Design filters on option value (often an id) by default; search visible labels instead. */
export function filterMapSelectOption(
  input: string,
  option?: MapSelectFilterOption
): boolean {
  const query = input.trim().toLowerCase();
  if (!query) return true;

  if (option?.options?.length) {
    return option.options.some((item) =>
      String(item.searchText ?? item.label ?? '')
        .toLowerCase()
        .includes(query)
    );
  }

  const haystack = String(
    option?.searchText ??
      (typeof option?.label === 'string' ? option.label : '') ??
      option?.value ??
      ''
  ).toLowerCase();

  return haystack.includes(query);
}

export const MAP_SELECT_SEARCH_PROPS = {
  showSearch: true,
  optionLabelProp: 'label' as const,
  filterOption: filterMapSelectOption,
} as const;

export const MAP_SELECT_PROPS = {
  width: '60%',
  height: '35px',
  bordercolor: 'var(--color-border, #dbeae3)',
  bgcolor: 'var(--color-surface-raised, #FFFFFF)',
  radius: '8px',
  rootClassName: 'scope-extraction-rules-select',
  popupClassName: 'extraction-rules-select-dropdown',
  ...MAP_SELECT_SEARCH_PROPS,
} as const;
